export default{
    setUsersRank(state, payload) {
        state.usersRank = payload;
    },
    setAutoLogout(state) {
        state.didAutoLogout = true;
    },
    setConnetcionUsers(state, payload)
    {
        state.connectionUsers = payload;
        // //여러 채널에 입장 가능
        // if(payload.connect)
        // {
        //     //같은 소켓 아이디가 아닐때 추가
        //     if(!state.connectionUsers.some((connect)=>connect.socketid === payload.socketid))
        //     {
        //         state.connectionUsers.push(payload.connect);        
        //     }
        // }
        // if(payload.disconnect)
        // {
        //     state.connectionUsers = state.connectionUsers.filter((user)=>user.socketid !== payload.disconnect)
        //     // const findItem = state.connectionUsers.find((user)=>user.socketid === payload.disconnect.socketid);
        //     // const idx = state.connectionUsers.indexOf(findItem);
        //     // state.connectionUsers.splice(idx,1);
        //     console.log('유저 접속 끊김');
        //     //state.connectionUsers.push(payload.connection);    
        // }
    }
};
